import { render } from "./Expenses.vue?vue&type=template&id=f8754722&ts=true"
import script from "./Expenses.vue?vue&type=script&lang=ts"
export * from "./Expenses.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__